import { ref } from 'vue'

interface AiChatMessage {
  message: string
  autoSubmit?: boolean
}

const messageQueue = ref<AiChatMessage[]>([])
const drawerShouldOpen = ref(false)

export const useAiChat = () => {
  const sendMessage = (message: string, autoSubmit = true) => {
    messageQueue.value.push({ message, autoSubmit })
    // Signal that the drawer should be opened
    drawerShouldOpen.value = true
  }

  const getNextMessage = () => {
    return messageQueue.value.shift()
  }

  const clearDrawerSignal = () => {
    drawerShouldOpen.value = false
  }

  return {
    sendMessage,
    getNextMessage,
    messageQueue,
    drawerShouldOpen,
    clearDrawerSignal
  }
} 